if (!customElements.get('price-request-dialog')) {
  class PriceRequestDialog extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.handleDocumentClick = (event) => {
        const trigger = event.target.closest('[data-por-open]');
        if (!trigger) return;
        event.preventDefault();
        this.open(trigger);
      };
      document.addEventListener('click', this.handleDocumentClick);

      this.dialog.addEventListener('click', (event) => {
        // The inner wrapper fills the dialog, so a click whose target is the
        // <dialog> itself landed on the backdrop.
        if (event.target === this.dialog || event.target.closest('[data-por-close]')) {
          this.close();
        }
      });

      // Fires for every close path, including the Esc key.
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('m-por-open');
        if (this.trigger) this.trigger.focus();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleDocumentClick);
    }

    open(trigger) {
      if (this.dialog.open) return;
      this.trigger = trigger;
      this.dialog.showModal();
      document.documentElement.classList.add('m-por-open');
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }
  }

  customElements.define('price-request-dialog', PriceRequestDialog);
}
